import React from "react";

const Reputation = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5571 5.09981C11.5571 4.35175 10.9486 3.74289 10.2002 3.74289C9.45175 3.74289 8.84326 4.35138 8.84326 5.09981C8.84326 5.84824 9.45175 6.45674 10.2002 6.45674C10.9486 6.45674 11.5571 5.84824 11.5571 5.09981Z"
        stroke="#215E9B"
        stroke-miterlimit="10"
      />
      <path
        d="M14.9131 7.16196C15.481 8.26337 16.0205 9.54608 15.5475 9.71408C14.8755 9.9526 13.1305 9.72589 12.0254 9.19494C12.0254 10.8849 12.0328 13.3946 12.0328 15.0299"
        stroke="#215E9B"
        stroke-miterlimit="10"
      />
      <path
        d="M13.0347 6.62103C13.3972 7.26497 13.943 8.22091 13.943 8.22091C13.943 8.22091 12.7518 7.68885 12.3601 7.61796C11.5769 7.47211 8.14457 7.51088 8.14457 7.51088C7.48918 7.53156 7.03872 7.82952 7.01288 8.49008C6.9538 9.99432 6.99921 11.8124 7.00549 13.3436C7.00734 13.8048 7.41829 13.9901 7.78457 14.0156C8.15085 14.0411 8.47097 13.7405 8.54851 13.3953"
        stroke="#215E9B"
        stroke-miterlimit="10"
      />
      <path
        d="M8.54871 13.3953C8.54501 13.618 8.55166 13.8476 8.54908 14.071C8.54908 14.0828 8.54723 14.0895 8.54723 14.1017C8.56126 16.1575 8.52618 18.3858 8.5572 20.3834C8.5668 20.9919 8.85184 21.2123 9.34071 21.2647C9.8292 21.3172 10.283 20.9675 10.2789 20.421C10.2811 18.3035 10.2789 16.2096 10.2797 14.098C10.29 14.1223 10.3085 14.0537 10.314 14.1367C10.3587 15.7004 10.1999 19.2561 10.2786 20.4214C10.2915 20.6138 10.3107 20.8279 10.4144 20.9959C10.6618 21.3966 11.4379 21.3371 11.7555 21.0554C11.9478 20.8844 12.0069 20.6119 12.0102 20.3653C12.0354 18.4383 12.0077 16.1239 12.0184 14.1039C12.0184 14.0921 12.0173 14.081 12.0169 14.0718C12.0169 14.0625 12.015 14.0422 12.018 14.0326"
        stroke="#215E9B"
        stroke-miterlimit="10"
      />
      <path
        d="M8.54908 13.3953C8.54908 13.3806 8.55388 13.3758 8.55388 13.3606C8.55388 12.0787 8.55388 10.7934 8.55388 9.51028C8.55203 9.51028 8.55019 9.51028 8.54834 9.51028C8.54834 10.8059 8.54908 12.0979 8.54908 13.3953Z"
        stroke="#215E9B"
        stroke-miterlimit="10"
      />
      <path
        d="M13.0347 6.62103L14.9133 7.16196"
        stroke="#215E9B"
        stroke-miterlimit="10"
      />
      <path
        d="M13.0345 6.62106L12.2676 6.40026L12.8971 4.94438L17.4623 4.19632V7.89564L14.9131 7.16198"
        stroke="#215E9B"
        stroke-miterlimit="10"
      />
      <path
        d="M19.8392 7.83287L18.5728 7.08813"
        stroke="#F9C438"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M20.2025 4.36765L18.5728 4.93995"
        stroke="#F9C438"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M18.5728 5.92764L20.0268 6.04469"
        stroke="#F9C438"
        stroke-width="2"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default Reputation;
